import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import EstateFlow from "./EstateFlow";
import GridConfig from "../GridConfig";

export default class EstateFlows extends Base {
    constructor(props) {
        super(props);
        this.state = {
            estateId: props.EstateId,
            estateFlowType: props.EstateFlowType,
            caller: props.Caller,
            controllerName: 'estateflow',
            IsV2: true,
            data: null,
            loading: true,
            configName: 'estateflow_grid',
            moduleName: 'موال'
        };
        this.state.filters = {
            estateId: this.state.estateId,
            estateFlowType: this.state.estateFlowType
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.refreshData();
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <EstateFlow EstateFlowType={this.state.estateFlowType} EstateId={this.state.estateId} Caller={this} Id={id} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <EstateFlow EstateFlowType={this.state.estateFlowType} EstateId={this.state.estateId} Caller={this} /> });
    }
    onGridConfig() {
        this.showComponents({ component: <GridConfig Caller={this} Config={this.getGridConfig()} /> });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "dateString", caption: "تاریخ", show: true },
                { field: "personName", caption: "شخص", show: true },
                { field: "quantity", caption: "تعداد", show: true },
                { field: "userName", caption: "کاربر", show: true },
            ]
        }
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'dateString' && f.show) t.push({ field: f.field, headerName: f.caption, cellRenderer: (props) => { return <a className="text-primary txt-bold hand" onClick={e => this.onEdit(props.data.id)}>{props.data.dateString}</a> } });
            if (f.field == 'personName' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'quantity' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'userName' && f.show) t.push({ field: f.field, headerName: f.caption });
        });
        return t;
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "width": "96%" }}>
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            {this.state.estateFlowType === 1 && <h4 className="modal-title">تخصیص ها</h4>}
                            {this.state.estateFlowType === 2 && <h4 className="modal-title">لغو تخصیص ها</h4>}
                            {this.state.estateFlowType === 3 && <h4 className="modal-title">خروجی ها</h4>}
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                {this.getToolBar(false, { add: true, print: true, pdf: true, excell: true, remove: true, config:false, otherFilters: null })}
                                {this.renderAgGrid({
                                    columnDefs: this.getColumns()
                                })}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm(),
                this.renderPopupComponent()
            ];

        return contents;
    }
}